var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout-list"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layout-list_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 11.667H11.666V15.0003H14.9993V11.667Z",
    fill: "#535456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.666 21.667V18.3337H14.9993V21.667H11.666Z",
    fill: "#535456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.666 25.0003V28.3337H14.9993V25.0003H11.666Z",
    fill: "#535456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 25.0003V28.3337H28.3327V25.0003H18.3327Z",
    fill: "#535456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 21.667V18.3337H18.3327V21.667H28.3327Z",
    fill: "#535456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3327 11.667V15.0003H18.3327V11.667H28.3327Z",
    fill: "#535456"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.e0579761b9f3c87dfa07f7e10d2d1451.svg";
export { ForwardRef as ReactComponent };